<?xml version="1.0" encoding="UTF-8"?>
<svg width="1000px" height="1000px" viewBox="0 0 1000 1000" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <rect id="checkbox-partial-path-1" x="0" y="0" width="1000" height="1000" rx="145"></rect>
    <filter x="-0.1%" y="-0.1%" width="100.3%" height="100.3%" filterUnits="objectBoundingBox" id="checkbox-partial-filter-2">
      <feGaussianBlur stdDeviation="1" in="SourceAlpha" result="shadowBlurInner1"></feGaussianBlur>
      <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset>
      <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
      <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
    </filter>
  </defs>
  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g>
      <use fill="currentColor" fill-rule="evenodd" xlink:href="#checkbox-partial-path-1"></use>
      <use fill="black" fill-opacity="1" filter="url(#checkbox-partial-filter-2)" xlink:href="#checkbox-partial-path-1"></use>
    </g>
    <polygon fill="#FFFFFF" fill-rule="nonzero" points="250 571.428571 750 571.428571 750 428.571429 250 428.571429"></polygon>
  </g>
</svg>
